export const removeExtension = (filename: string): string => filename.replace(/\.[^/.]+$/, '');

export const replaceExtension = (filename: string, newExtension: string): string =>
  filename.replace(/\.[^/.]+$/, newExtension.startsWith('.') ? newExtension : `.${newExtension}`);

export const isImageMimeType = (mimeType?: string): boolean => !!mimeType?.startsWith('image/');

export const isVideoMimeType = (mimeType?: string): boolean => !!mimeType?.startsWith('video/');

export const bytesToMB = (bytes: number): string => (bytes / 1_048_576).toFixed(1);
